export default __webpack_public_path__ + "static/sponsorship-28ecd29c8ccbae7b41744579746f4911.png";